import { render, staticRenderFns } from "./PaperCard.vue?vue&type=template&id=d4505e76&"
import script from "./PaperCard.vue?vue&type=script&lang=js&"
export * from "./PaperCard.vue?vue&type=script&lang=js&"
import style0 from "./PaperCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PaperCard.vue"
export default component.exports